// Login session token storage. Held in localStorage (like the mock identity)
// so both React and the non-React axios interceptor can read it synchronously.
const STORAGE_KEY = 'dnd-editor-session-token';
export function getSessionToken() {
    try {
        return localStorage.getItem(STORAGE_KEY);
    }
    catch (_a) {
        return null;
    }
}
export function setSessionToken(token) {
    try {
        localStorage.setItem(STORAGE_KEY, token);
    }
    catch (_a) {
        /* ignore storage failures */
    }
}
export function clearSessionToken() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    }
    catch (_a) {
        /* ignore storage failures */
    }
}
